// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__19P6G","info":"Note_info__1kTiq","note":"Note_note__u-XKL","actions":"Note_actions__1K2Ob"};